/**
 * Whether the organization emails a donor receipt when staff mark a hand-entered gift reviewed
 * (#6479). A per-organization setting, off unless the organization turned it on: receipt
 * practice is church policy, and emailing a donor is not something to start by default.
 * Read from the organization's stored settings (`settings.sendReceiptOnReview`), which the
 * Contribution defaults page writes.
 */
export function sendsReceiptOnReview(settings: unknown): boolean {
  return (
    typeof settings === "object"
    && settings !== null
    && !Array.isArray(settings)
    && (settings as { sendReceiptOnReview?: unknown }).sendReceiptOnReview === true
  );
}
